import React from "react";
import NavBar from "../components/homePage/navBar";
import Store from "../components/store/store";

const StorePage: React.FC = () => {
    return (
        <div>
            <NavBar />
            <Store />
        </div>
    )
}

export default StorePage;